import {
    Alert,
    Box,
    Button,
    Card,
    Divider,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { AuthService, LoginErrorCode } from "../../api/psc.ts";
import RenderWhen from "../../components/RenderWhen";
import Spinner from "../../components/Spinner";

export default function () {
    const query = new URLSearchParams(window.location.search);

    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>();

    const handleLogin = () => {
        AuthService.login({
            username: userName,
            password: password,
            contextId: query.get("c"),
        })
            .then((response) => {
                console.log("after response", response);
                switch (response.code) {
                    case LoginErrorCode.SUCCESS:
                        window.location = response.redirectUrl as any;
                        break;
                    case LoginErrorCode.ACCOUNT_DISABLED:
                        setErrorMessage("حساب کاربری شما مسدود شده است.");
                        break;
                    case LoginErrorCode.INVALID_CRED:
                        setErrorMessage("اطلاعات وارد شده اشتباه است.");
                        break;
                }
            })
            .catch((err) => {
                setErrorMessage("اطلاعات وارد شده اشتباه است.");
            });
    };

    const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUserName(e.target.value);
    };

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
    };

    return (
        <Box
            display="flex"
            height="100dvh"
            justifyContent="center"
            alignItems="center"
            flexDirection="row"
        >
            <Card
                sx={{
                    padding: 3,
                    width: { md: "30dvw", xs: "95dvw", lg: "18dvw" },
                }}
            >
                <Stack spacing={2}>
                    <Typography textAlign="center">
                        ورود پنل مدیریت پرشین سازه
                    </Typography>
                    <Divider />
                    <TextField
                        onChange={handleUsernameChange}
                        label="نام کاربری"
                        value={userName}
                        variant="outlined"
                    />
                    <TextField
                        type="password"
                        onChange={handlePasswordChange}
                        label="رمز عبور"
                        value={password}
                        variant="outlined"
                    />
                    <Button variant="contained" onClick={handleLogin}>
                        ورود
                    </Button>

                    <RenderWhen
                        component={
                            <Alert
                                sx={{ alignItems: "center" }}
                                severity="error"
                            >
                                {errorMessage}
                            </Alert>
                        }
                        condition={!!errorMessage}
                    />
                </Stack>
            </Card>

            <RenderWhen component={<Spinner />} condition={false} />
        </Box>
    );
}
